import { CommanderMonitoringFilterLogicalObject } from '../../monitoring/api/util/filter/filter.model';

export const filtersAreEmpty = (
  commanderMonitoringFilterLogicalObject: CommanderMonitoringFilterLogicalObject
) => {
  for (const deviceId in commanderMonitoringFilterLogicalObject) {
    for (const controlUnitId in commanderMonitoringFilterLogicalObject[
      deviceId
    ]) {
      const controlUnitObjectFilter =
        commanderMonitoringFilterLogicalObject[deviceId][controlUnitId];
      for (const eventId in controlUnitObjectFilter) {
        if (controlUnitObjectFilter[eventId]) {
          return false;
        }
      }
    }
  }
  return true;
};
